import { useMutation, useQueryClient } from "@tanstack/react-query";
import ProgramTemplatesService from "../../../services/ProgramTemplatesService";
import { ICreateProgramTemplateCommand } from "@growth-machine-llc/stridist-api-client";
import { useToastAlert } from "../../../components/app/ToastAlert/ToastAlertProvider";
import { COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY } from "../../program-library/ProgramsTableScreen";

export const useCreateProgramTemplateMutation = () => {
  const queryClient = useQueryClient();
  const { showToastAlert } = useToastAlert();

  return useMutation({
    mutationFn: (variables: ICreateProgramTemplateCommand) =>
      ProgramTemplatesService.createProgramTemplate(variables),
    onSuccess: () => {
      // Invalidate program templates query to refresh the list
      queryClient.invalidateQueries({
        queryKey: [COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY],
      });
      showToastAlert("success", {
        message: "Template created successfully",
      });
    },
    onError: (error) => {
      showToastAlert("error", {
        message: "Failed to create template. Please try again.",
      });
    },
  });
};

